import { root } from "src/root";

type NeuralQA = { answer: string; question: string; responder: "ai" | "expert" };

const neuralQAPublicApi = root.domain("neuralQA-public");

export const updateNeuralQAEvent = neuralQAPublicApi.event<NeuralQA[]>();

export const toggleNeuralModalOpenStatus = neuralQAPublicApi.event<boolean>();
